// Inject sticky ATC styles
const style = document.createElement("style");
style.innerHTML = `
  .sticky-add-to-cart {
    display: none;
    padding: 15px 64px;
    z-index: 9999;
    transition: transform 0.3s ease;
  }
  .sticky-add-to-cart.desktop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid rgba(20, 43, 111, 0.2);
    background: #fff;
    box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.1);
  }
  .sticky-add-to-cart.mobile {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
  }
  .sticky-add-to-cart-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1472px;
    max-width: 100%;
    margin: auto;
  }
  .sticky-add-to-cart .product-title {
    font-weight: bold;
    font-size: 26px;
    flex: 1;
    color: #142b6f;
  }
  .sticky-add-to-cart .order-btn {
    background: #000;
    color: #fff;
    padding: 15px 50px;
    border: none;
    border-radius: 106px;
    font-weight: bold;
    font-size: 19px;
    cursor: pointer;
    background-color: #142b6f;
    transition: .3s ease opacity;
  }
  .sticky-add-to-cart .order-btn:hover {
    opacity: 0.5;
  }
  .sticky-add-to-cart.mobile .order-btn {
    width: 100%;
  }
  .sticky-add-to-cart.mobile {
    padding: 15px 30px;
  }
`;
document.head.appendChild(style);

document.addEventListener("DOMContentLoaded", () => {
  const target =
    document.querySelector('[data-instant-action-type="add-to-cart"]') ||
    document.querySelector('[data-instant-action-type="redirect-to-cart"]') ||
    document.querySelector(".checkout-btn") ||
    document.querySelector(".NCOffer2Button");
  const variantPicker =
    document.querySelector(".instant-custom-variant-picker") ||
    document.querySelector(".instant-selling-plan-selector");

  if (!target || !variantPicker) return;

  const stickyBar = document.createElement("div");
  stickyBar.className = "sticky-add-to-cart";
  document.body.appendChild(stickyBar);

  const productTitleInput = document.getElementById(
    "product-name-for-sticky-atc"
  );
  const productTitle = productTitleInput?.value || "Product";

  stickyBar.innerHTML = `
    <div class="sticky-add-to-cart-inner"><span class="product-title">${productTitle}</span>
    <button class="order-btn">Order Now +</button></div>
  `;

  const orderBtn = stickyBar.querySelector(".order-btn");
  orderBtn?.addEventListener("click", () => {
    const header = document.getElementById("iw61qYOfmQo4ixtlC");
    const headerHeight = header?.offsetHeight || 0;

    const scrollTarget =
      document.querySelector(".bags-number") ||
      document.querySelector(".instant-custom-variant-picker") ||
      document.querySelector(".instant-selling-plan-selector");

    if (scrollTarget) {
      const elementTop =
        scrollTarget.getBoundingClientRect().top + window.scrollY;
      const offsetTop = elementTop - headerHeight - 10;

      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  });

  const isMobile = () => window.innerWidth <= 768;

  const updateSticky = () => {
    const rect = target?.getBoundingClientRect();
    if (!rect) return;

    if (rect.bottom < 0) {
      stickyBar.style.display = "block";
      stickyBar.classList.toggle("desktop", !isMobile());
      stickyBar.classList.toggle("mobile", isMobile());
      stickyBar
        .querySelector(".product-title")
        ?.style.setProperty("display", isMobile() ? "none" : "inline-block");
    } else {
      stickyBar.style.display = "none";
    }
  };

  window.addEventListener("scroll", updateSticky);
  window.addEventListener("resize", updateSticky);
  updateSticky();
});

// --- Slider functionality ---
const carousel = document.querySelector(
  ".cart-recommended-products-inner-carousel"
);
const items = document.querySelectorAll(".cart-recommended-product-carousel");

let itemWidth = 0;
if (items.length > 0) {
  const itemStyle = getComputedStyle(items[0]);
  itemWidth = items[0].offsetWidth + parseInt(itemStyle.marginRight || 0);
}

let currentOffset = 0;
let isDown = false;
let startX;
let scrollStart;

function snapToNearest() {
  if (!carousel || itemWidth === 0) return;
  const slideIndex = Math.round(-currentOffset / itemWidth);
  currentOffset = -slideIndex * itemWidth;
  carousel.style.transform = `translateX(${currentOffset}px)`;
}

if (carousel && items.length > 0) {
  carousel.addEventListener("mousedown", (e) => {
    isDown = true;
    carousel.classList.add("dragging");
    startX = e.pageX;
    scrollStart = currentOffset;
  });

  carousel.addEventListener("mouseleave", () => {
    isDown = false;
    carousel.classList.remove("dragging");
  });

  carousel.addEventListener("mouseup", () => {
    isDown = false;
    carousel.classList.remove("dragging");
    snapToNearest();
  });

  carousel.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    const dx = e.pageX - startX;
    carousel.style.transform = `translateX(${scrollStart + dx}px)`;
    currentOffset = scrollStart + dx;
  });

  carousel.addEventListener(
    "touchstart",
    (e) => {
      isDown = true;
      startX = e.touches[0].clientX;
      scrollStart = currentOffset;
    },
    { passive: true }
  );

  carousel.addEventListener(
    "touchmove",
    (e) => {
      if (!isDown) return;
      const dx = e.touches[0].clientX - startX;
      carousel.style.transform = `translateX(${scrollStart + dx}px)`;
      currentOffset = scrollStart + dx;
    },
    { passive: true }
  );

  carousel.addEventListener("touchend", () => {
    isDown = false;
    snapToNearest();
  });
}

document
  .querySelector(".cart-recommended-products-top-icon-right")
  ?.addEventListener("click", (e) => {
    e.preventDefault();
    const maxOffset = -(items.length - 1) * itemWidth;
    currentOffset -= itemWidth;
    if (currentOffset < maxOffset) currentOffset = maxOffset;
    carousel?.style.setProperty("transform", `translateX(${currentOffset}px)`);
  });

document
  .querySelector(".cart-recommended-products-top-icon-left")
  ?.addEventListener("click", (e) => {
    e.preventDefault();
    currentOffset += itemWidth;
    if (currentOffset > 0) currentOffset = 0;
    carousel?.style.setProperty("transform", `translateX(${currentOffset}px)`);
  });

document.addEventListener("instant:add-to-cart", () => {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates: {},
      sections: ["cart-drawer", "cart-icon-bubble"],
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      document.querySelector("cart-drawer")?.renderContents(cart);
      document
        .querySelector("cart-drawer.drawer")
        ?.classList.remove("is-empty");
    });
});

// --- Delegated ATC for cart recommended ---
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (event) {
    const button = event.target.closest(".cart-recommended-product-atc");
    if (!button) return;

    event.preventDefault();
    const productId = button.getAttribute("data-product-id");
    if (!productId) return;

    const productElement = button.closest(".cart-recommended-product");
    const loadingSpinner = productElement?.querySelector(".loading__spinner");

    if (loadingSpinner) loadingSpinner.classList.remove("hidden");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: productId, quantity: 1 }),
    })
      .then((res) =>
        res.ok ? res.json() : res.json().then((err) => Promise.reject(err))
      )
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        const selectors = [
          ".drawer__header",
          ".free-shipping-progress-block",
          ".cart__contents",
          ".cart-drawer__footer",
        ];
        selectors.forEach((selector) => {
          const newEl = html.querySelector(selector);
          const oldEl = document.querySelector(selector);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });

        if (productElement) productElement.style.display = "none";
      })
      .catch(console.error)
      .finally(() => loadingSpinner?.classList.add("hidden"));
  });
});

// --- Subscription Conversion ---
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (event) {
    const button = event.target.closest(".convert-to-subscription");
    if (!button) return;

    event.preventDefault();
    const variantId = button.getAttribute("data-variant-id");
    const cartItem = button.closest(".cart-item");
    const quantity =
      parseInt(cartItem?.querySelector(".quantity__input")?.value) || 1;
    const sellingPlanId = button.getAttribute("data-selling_plan_id");
    if (!sellingPlanId || !variantId) return;

    button.textContent = "Saving...";

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity,
        selling_plan: sellingPlanId,
      }),
    })
      .then((res) => res.json())
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        const selectors = [
          ".drawer__header",
          ".free-shipping-progress-block",
          ".cart__contents",
          ".cart-drawer__footer",
        ];
        selectors.forEach((selector) => {
          const newEl = html.querySelector(selector);
          const oldEl = document.querySelector(selector);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });
      })
      .catch((err) => {
        console.error(err);
        button.textContent = "Save 10%";
      });
  });
});

// --- Subscription dropdown ---
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("change", function (event) {
    const select = event.target.closest("select");
    if (!select) return;

    const wrapper = select.closest(".select-subscription");
    const variantId = wrapper?.getAttribute("data-variant-id");
    const cartItem = select.closest(".cart-item");
    const quantity =
      parseInt(cartItem?.querySelector(".quantity__input")?.value) || 1;
    if (!variantId || quantity <= 0) return;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity,
        selling_plan: select.value,
      }),
    })
      .then((res) => res.json())
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        const selectors = [
          ".drawer__header",
          ".free-shipping-progress-block",
          ".cart__contents",
          ".cart-drawer__footer",
        ];
        selectors.forEach((selector) => {
          const newEl = html.querySelector(selector);
          const oldEl = document.querySelector(selector);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });
      })
      .catch(console.error);
  });
});

// --- Cart trigger ---
document.querySelector(".cart-trigger")?.addEventListener("click", () => {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.toggle("active");
    document.body.classList.add("overflow-hidden");
  }
});

// --- Header scroll hide ---
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".shopify-section-group-header-group");
  if (!header) return;

  let lastScroll = window.scrollY;
  header.style.transition = "opacity 0.3s ease";

  window.addEventListener("scroll", () => {
    const current = window.scrollY;
    if (current > lastScroll && current > 0) {
      header.style.opacity = "0";
      header.style.pointerEvents = "none";
    } else {
      header.style.opacity = "1";
      header.style.pointerEvents = "auto";
    }
    lastScroll = current <= 0 ? 0 : current;
  });
});

// --- Popup fade on homepage ---
document.addEventListener("DOMContentLoaded", () => {
  const isHome = window.location.href === "https://clearly.eu/";
  const popup = document.querySelector(".language-popup");
  const body = document.body;
  const trigger = document.querySelector(".language-popup-trigger");
  const closeBtn = document.querySelector(".close-language-popup");

  const fadeIn = (el, dur = 400) => {
    if (!el) return;
    el.style.opacity = 0;
    el.style.display = "block";
    el.style.transition = `opacity ${dur}ms ease`;
    requestAnimationFrame(() => (el.style.opacity = 1));
  };

  const fadeOut = (el, dur = 400) => {
    if (!el) return;
    el.style.transition = `opacity ${dur}ms ease`;
    el.style.opacity = 0;
    setTimeout(() => (el.style.display = "none"), dur);
  };

  if (isHome && popup) {
    setTimeout(() => {
      fadeIn(popup);
      body.classList.add("language-popup-open");
    }, 1500);
  }

  trigger?.addEventListener("click", (e) => {
    e.preventDefault();
    fadeIn(popup);
    body.classList.add("language-popup-open");
  });

  closeBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    fadeOut(popup);
    body.classList.remove("language-popup-open");
  });

  setTimeout(() => {
    document.querySelectorAll(".language-popup-language a").forEach((link) => {
      link.setAttribute("target", "_self");
    });
  }, 1500);
});

document.addEventListener("DOMContentLoaded", function () {
  const bagsNumber = document.querySelectorAll(".bags-number");
  const rewards = document.querySelector(".free-rewards");
  const rewardChildren = rewards ? Array.from(rewards.children || []) : [];

  // Target text elements
  const cupPrice = document.querySelector(".cup-price strong");
  const bagsPrice = document.querySelector(".bags-price strong");
  const fullPrice = document.querySelector(".bags-full-price p");
  const savedOnBags = document.querySelector(".saved-on-bags strong");

  if (!bagsNumber.length) return;

  bagsNumber.forEach((bagNumber) => {
    if (!bagNumber) return;

    const children = Array.from(bagNumber.children || []);
    if (!children.length) return;

    // Set default active-bag if none
    if (!children.some((child) => child.classList?.contains("active-bag"))) {
      children[1]?.classList?.add("active-bag");
      updateRewards(1); // default to second child logic
    } else {
      const activeIndex = children.findIndex((c) =>
        c.classList?.contains("active-bag")
      );
      updateRewards(activeIndex);
    }

    // Add click listeners to each first-level child
    children.forEach((child, index) => {
      if (!child) return;
      child.addEventListener("click", () => {
        children.forEach((c) => c?.classList?.remove("active-bag"));
        child.classList?.add("active-bag");
        updateRewards(index);
      });
    });
  });

  function updateRewards(selectedIndex) {
    if (!rewardChildren.length) return;

    rewardChildren.forEach((el) => el.classList.remove("active-reward"));

    if (selectedIndex === 0) {
      // First bag child selected – activate all
      rewardChildren.forEach((el) => el.classList.add("active-reward"));
    } else if (selectedIndex === 1) {
      // Second bag child selected – activate first 2
      rewardChildren[0]?.classList.add("active-reward");
      rewardChildren[1]?.classList.add("active-reward");
      rewardChildren[2]?.classList.add("active-reward");
    } else if (selectedIndex === 2) {
      // Third bag child selected – activate first only
      rewardChildren[0]?.classList.add("active-reward");
     // rewardChildren[1]?.classList.add("active-reward");
    }

    // Update text content
    if (cupPrice && bagsPrice && fullPrice && savedOnBags) {
      const currency = document.querySelector(
        'meta[name="shop-currency"]'
      )?.content;
      let textMap = [];
      if (window.location.host == "clearly.pl") {
        textMap = [
          {
            cup: "3.33 zł ",
            bags: "300 zł",
            full: "500",
            saved: "-46%",
          },
          {
            cup: "3.55 zł ",
            bags: "212.5 zł",
            full: "375",
            saved: "-43%",
          },
          {
            cup: "3.75 zł ",
            bags: "112.5 zł",
            full: "145",
            saved: "-22%",
          },
        ];
      } else {
        textMap = [
          {
            cup: "€0.7 ",
            bags: "€62.95",
            full: "€129.95",
            saved: "-51%",
          },
          {
            cup: "€0.8 ",
            bags: "€47.95",
            full: "€79.95",
            saved: "-39%",
          },
          {
            cup: "€0.9 ",
            bags: "€27",
            full: "€30",
            saved: "-10%",
          },
        ];
      }

      const text = textMap[selectedIndex];
      cupPrice.textContent = text.cup;
      bagsPrice.textContent = text.bags;
      fullPrice.textContent = text.full;
      savedOnBags.textContent = text.saved;
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const checkoutBtn = document.querySelector(".checkout-btn");
  if (!checkoutBtn) return;

  checkoutBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    // Add loading state
    checkoutBtn.classList.add("instant-loading");
    checkoutBtn.style.cursor = "wait";
    checkoutBtn.setAttribute("disabled", "disabled");

    const activeOption = document.querySelector(
      '.instant-custom-variant-picker[data-instant-state="active"]'
    );
    const notCoffeeVariant = activeOption?.getAttribute(
      "data-instant-option-value"
    );
    var not_coffee_id;
    if (notCoffeeVariant == "Original") {
      not_coffee_id = 47145860530506;
    } else {
      not_coffee_id = 47145860563274;
    }
    const bagsNumber = document.querySelector(".bags-number");
    if (!bagsNumber) return;

    const firstChild = bagsNumber.children[0];
    const secondChild = bagsNumber.children[1];
    const thirdChild = bagsNumber.children[2];
    var items,
      discountCode = "",
      properties;
    if (thirdChild?.classList.contains("active-bag")) {
      items = [
        {
          id: not_coffee_id,
          quantity: 1,
          //selling_plan: 691789594954,
        },
      ];
      discountCode = "NCOFFER1";
    } else if (secondChild?.classList.contains("active-bag")) {
      items = [
        {
          id: not_coffee_id,
          quantity: 2,
        },
        {
          id: 49560282005834,
          quantity: 1,
        },
      ];
      discountCode = "NCOFFER2,Free Clearly Shipping,FREEGIFT1";
    } else if (firstChild?.classList.contains("active-bag")) {
      items = [
        {
          id: not_coffee_id,
          quantity: 3,
        },
        {
          id: 49560282005834,
          quantity: 1,
        },
        {
          id: 51054433337674,
          quantity: 1,
        },
      ];
      discountCode = "NCOFFER3,FREEGIFT2";
    }
    console.log(window.location.pathname);
    try {
      // Clear the cart
      await fetch("/cart/clear.js", { method: "POST" });

      for (const item of items) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.id,
            quantity: item.quantity,
            properties: item.properties,
            //selling_plan: item.selling_plan,
          }),
        });
      }

      // Go to checkout
      const checkoutUrl = discountCode
        ? "/checkout/?discount=" + discountCode
        : "/checkout";
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("Add-to-cart failed:", error);

      // Optionally rollback UI if failed
      checkoutBtn.classList.remove("instant-loading");
      checkoutBtn.style.cursor = "";
      checkoutBtn.removeAttribute("disabled");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".NCQtySelector");
  if (!container) return;

  const children = container.children;

  // Set second child active by default
  if (children[1]) {
    children[1].classList.add("ActiveSelector");
  }

  // Handle click to swap ActiveSelector
  Array.from(children).forEach((child) => {
    child.addEventListener("click", () => {
      Array.from(children).forEach((c) => c.classList.remove("ActiveSelector"));
      child.classList.add("ActiveSelector");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const offerBtn = document.querySelector(".NCOffer2Button");
  if (!offerBtn) return;

  offerBtn.addEventListener("click", async function (e) {
    e.preventDefault();
    // Add loading state
    offerBtn.classList.add("instant-loading");
    offerBtn.style.cursor = "wait";
    offerBtn.setAttribute("disabled", "disabled");
    try {
      // ----- FLAVOR SELECTION -----
      const flavorContainer = document.querySelector(".NCFlavorSelector");
      const flavorChildren = flavorContainer ? flavorContainer.children : [];
      let variantId = null;

      if (flavorChildren[0]?.getAttribute("data-instant-state") === "active") {
        variantId = 47145860530506;
      } else if (
        flavorChildren[1]?.getAttribute("data-instant-state") === "active"
      ) {
        variantId = 47145860563274;
      }

      if (!variantId) {
        console.warn("No valid flavor selected.");
        return;
      }

      // ----- QUANTITY SELECTION -----
      const qtyContainer = document.querySelector(".NCQtySelector");
      const qtyChildren = qtyContainer ? qtyContainer.children : [];
      let quantity = 1;
      Array.from(qtyChildren).forEach((child, index) => {
        if (child?.classList?.contains("ActiveSelector")) {
          quantity = index + 1;
        }
      });

      // ----- DISCOUNT CODE -----
      let discountCode = "";
      if (quantity === 2) discountCode = "DEAL";
      else if (quantity === 3) discountCode = "DEAL2";

      // ----- ADD TO CART -----
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity }),
      });

      if (!addRes.ok) {
        console.error("Add to cart failed.");
        return;
      }

      // -----> Only continue if ATC succeeded <-----

      // ----- APPLY DISCOUNT CODE -----
      if (discountCode) {
        try {
          await fetch(`/discount/${discountCode}`);
        } catch (e) {
          console.warn("Discount code apply failed:", discountCode);
        }
      }

      // ----- UPDATE CART DRAWER -----

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((res) => res.text())
        .then((htmlText) => {
          const html = new DOMParser().parseFromString(htmlText, "text/html");
          const selectors = [".cart-drawer"];

          selectors.forEach((selector) => {
            const newEl = html.querySelector(selector);
            const oldEl = document.querySelector(selector);
            if (newEl && oldEl) oldEl.replaceWith(newEl);
          });

          // After all replacements, reset button state
          offerBtn.classList.remove("instant-loading");
          offerBtn.style.cursor = "";
          offerBtn.removeAttribute("disabled");

          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            if (cartDrawer?.classList?.contains("is-empty")) {
              cartDrawer.classList.remove("is-empty");
            }
            setTimeout(function () {
              cartDrawer.classList.toggle("active");
              document.body.classList.add("overflow-hidden");
            }, 300);
          }
        })
        .catch((err) => {
          console.error("Cart drawer refresh failed:", err);
          // Optional: also reset button if fetch fails
          offerBtn.classList.remove("instant-loading");
          offerBtn.style.cursor = "";
          offerBtn.removeAttribute("disabled");
        });
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  });
});

// Check if both elements exist
let priceElem = document.querySelector('.full-price-single-var');
let discountSpan = document.querySelector('.discounted-price-single-var span');

if (priceElem && discountSpan) {
    
    let priceText = priceElem.textContent.trim();

    // Remove currency symbols and spaces
    let numericText = priceText.replace(/[^\d,\.]/g, '').replace(',', '.');

    let price = parseFloat(numericText);

    // Proceed only if price is a valid number
    if (!isNaN(price)) {
        let discountedPrice = (price * 0.8).toFixed(2);

        // Detect currency symbol (everything before first digit)
        let currencyMatch = priceText.match(/^[^\d]+/);
        let currency = currencyMatch ? currencyMatch[0].trim() : '';

        // Keep decimal style consistent with original price
        if (priceText.includes(',')) {
            discountedPrice = discountedPrice.replace('.', ',');
        }

        // Update discounted price in span
        discountSpan.textContent = currency + discountedPrice;
    }
}

/* CART Count START */
document.addEventListener("DOMContentLoaded", function () {
  var HOST_SEL = ".cart-trigger";
  var BADGE_CLASS = "cart-counter";
  var CART_RE = /\/cart(\/|\.js|\?|$)|\/cart\/(add|update|change|clear)(\.js)?/i;
  var refreshTimer = null;

  function ensureBadge() {
    var host = document.querySelector(HOST_SEL);
    if (!host) return null;
    var badge = host.querySelector("." + BADGE_CLASS);
    if (!badge) {
      badge = document.createElement("span");
      badge.className = BADGE_CLASS;
      host.appendChild(badge);
    }
    return badge;
  }

  function setCount(n) {
    var badge = ensureBadge();
    if (!badge) return;
    var current = badge.textContent;
    var next = n > 0 ? String(n) : "";
    if (current !== next) {
      badge.textContent = next;
    }
  }


  function refreshCount() {
    fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(r => r.json())
      .then(cart => setCount(cart && cart.item_count || 0))
      .catch(() => {});
  }

  function kickRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCount, delay || 100);
  }

  // Initial count
  ensureBadge();
  refreshCount();

  // ---- Global cart hook ----
  if (!window.__cartHookInstalled) {
    window.__cartHookInstalled = 1;

    function emitChanged() {
      document.dispatchEvent(new CustomEvent("cart:changed"));
    }

    // Patch fetch
    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        try {
          var req = args[0];
          var url = (req && req.url) ? req.url : String(req || "");
          if (CART_RE.test(url)) {
            return _fetch.apply(this, args).then(function (res) {
              setTimeout(emitChanged, 0);
              return res;
            });
          }
        } catch (_) {}
        return _fetch.apply(this, args);
      };
    }

    // Patch XHR
    if (window.XMLHttpRequest) {
      var XO = XMLHttpRequest.prototype.open;
      var XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, url) {
        this.__watchCart = typeof url === "string" && CART_RE.test(url);
        return XO.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__watchCart) this.addEventListener("loadend", emitChanged, { once: true });
        return XS.apply(this, arguments);
      };
    }
  }

  // Listen for cart changes
  document.addEventListener("cart:changed", function () { kickRefresh(100); });

  // Sync when Dawn reloads header sections
  document.addEventListener("shopify:section:load", function () { kickRefresh(0); }, true);
});

/* CART Count END */

/* Bundles JS Start */
(function () {
  // Extra guard: do nothing if no wrappers exist
  if (!document.querySelector('.bundle-wrapper')) return;

  document.addEventListener('DOMContentLoaded', function () {
    var wrappers = document.querySelectorAll('.bundle-wrapper');
    if (!wrappers.length) return;

    /* ===== Money helpers ===== */
    function getMoneyFormat(wrapper) {
      var fromTheme = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : null;
      var fromShop  = (window.Shopify && Shopify.money_format) ? Shopify.money_format : null;
      var fromData  = wrapper ? wrapper.getAttribute('data-money-format') : null;
      return fromTheme || fromShop || fromData || null;
    }
    function formatMoneyNoZeros(cents, wrapper) {
  var fmt = getMoneyFormat(wrapper);
  if (fmt && window.Shopify && typeof Shopify.formatMoney === 'function') {
    var out = Shopify.formatMoney(cents, fmt);
    // Remove only .00 — leave other decimals intact
    return out.replace(/([.,]00)(?!\d)/, '');
  }
  
  var value = (cents / 100).toFixed(2); // always 2 decimals
  if (value.endsWith('.00')) value = value.slice(0, -3); // strip if .00 only
  
  if (fmt && typeof fmt === 'string') {
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, value.replace(/\..*$/, ''))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, value.replace(/\..*$/, '').replace('.', ','));
  }
  return value;
}

    function readCents(input) {
      if (!input) return 0;
      var raw = String(input.value || '').trim();
      if (!raw) return 0;
      if (raw.indexOf('.') > -1) return Math.round(parseFloat(raw) * 100);
      var n = parseInt(raw, 10);
      return isNaN(n) ? 0 : n;
    }

    function setSelectedClass(card, cfg, qty) {
      var className = (cfg.mode === 'variants') ? 'variant-added' : 'product-added';
      if (!card) return;
      if ((qty || 0) > 0) {
        card.classList.add(className);
      } else {
        card.classList.remove(className);
      }
    }


    function getModeConfig(wrapper) {
      // If wrapper explicitly has a variants list → variants mode
      if (wrapper.querySelector('.bundle-variants')) {
        return {
          mode: 'variants',
          cardSelector: '.bundle-variant',
          actionSelector: '.bundle-variant-action',
          addBtnSelector: '.bundle-variant-add',
          emptyAlert: 'Select at least 1 variant.'
        };
      }
      // Else assume products mode (if you render a products list in another wrapper)
      if (wrapper.querySelector('.bundle-products')) {
        return {
          mode: 'products',
          cardSelector: '.bundle-product',
          actionSelector: '.bundle-product-action',
          addBtnSelector: '.bundle-product-add',
          emptyAlert: 'Select at least 1 product.'
        };
      }
      // No known list inside → neutral (no binding)
      return { mode: 'none' };
    }

    for (var w = 0; w < wrappers.length; w++) (function (wrapper) {
      // prevent duplicate binding on re-renders
      if (wrapper.dataset.bound === 'true') return;
      wrapper.dataset.bound = 'true';

      var cfg = getModeConfig(wrapper);
      if (cfg.mode === 'none') return; // nothing to wire inside this wrapper

      var atc          = wrapper.querySelector('.bundle-atc');
      var totalEl      = atc ? atc.querySelector('.bundle-total') : null;
      var fullTotalEl  = atc ? atc.querySelector('.bundle-full-total') : null;

      /* ----- Plan helpers ----- */
      function syncSubscriptionSelectVisibility() {
        var subTab  = wrapper.querySelector('.bundle-plan[data-plan="subscribe"]');
        var subWrap = subTab ? subTab.querySelector('.choose-bundle-subscription-wrapper') : null;
        var activePlan = wrapper.querySelector('.bundle-plan.bundle-plan-active');
        if (subWrap) {
          var show = !!(activePlan && activePlan.getAttribute('data-plan') === 'subscribe');
          subWrap.style.display = show ? 'block' : 'none';
        }
      }
      function getActiveSellingPlanId() {
        var activePlan = wrapper.querySelector('.bundle-plan.bundle-plan-active');
        if (!activePlan || activePlan.getAttribute('data-plan') !== 'subscribe') return null;
        var selectEl = activePlan.querySelector('.choose-bundle-subscription');
        if (!selectEl) return null;
        var id = parseInt(selectEl.value, 10);
        return isNaN(id) ? null : id;
      }

      /* ----- Totals/CTA ----- */
      function updateCTAForWrapper() {
  var totalQty = 0, totalCents = 0;
  var cards = wrapper.querySelectorAll(cfg.cardSelector);

  for (var i = 0; i < cards.length; i++) {
    var card = cards[i];
    var qtyInput   = card.querySelector('.bundle-qty-number');
    var priceInput = card.querySelector('.var-price');
    var qty   = parseInt(qtyInput && qtyInput.value, 10) || 0;
    var cents = readCents(priceInput);

    // NEW: keep the card’s selected class in sync
    setSelectedClass(card, cfg, qty);

    totalQty   += qty;
    totalCents += qty * cents;
  }

  var activePlan = wrapper.querySelector('.bundle-plan.bundle-plan-active');
  var isSubscribe = !!(activePlan && activePlan.getAttribute('data-plan') === 'subscribe');
  var active = totalQty > 0;

  if (!atc) return;

  atc.classList.toggle('is-active', active);
  atc.classList.toggle('subscribe-mode', active && isSubscribe);

  if (!active) {
    if (totalEl)     totalEl.textContent = '';
    if (fullTotalEl) fullTotalEl.textContent = '';
    return;
  }
  if (isSubscribe) {
    var discounted = Math.round(totalCents * 0.9);
    if (fullTotalEl) fullTotalEl.textContent = formatMoneyNoZeros(totalCents, wrapper);
    if (totalEl)     totalEl.textContent     = formatMoneyNoZeros(discounted, wrapper);
  } else {
    if (fullTotalEl) fullTotalEl.textContent = '';
    if (totalEl)     totalEl.textContent     = formatMoneyNoZeros(totalCents, wrapper);
  }
}


      /* ----- Qty UI (Add ↔ Qty) ----- */
      var actions = wrapper.querySelectorAll(cfg.actionSelector);
      for (var a = 0; a < actions.length; a++) (function (action) {
        var addBtn   = action.querySelector(cfg.addBtnSelector);
        var qtyBlock = action.querySelector('.bundle-qty');
        var minusBtn = action.querySelector('.bundle-qty-minus');
        var plusBtn  = action.querySelector('.bundle-qty-plus');
        var input    = action.querySelector('.bundle-qty-number');

        if (qtyBlock) qtyBlock.style.display = 'none';
        if (input)    input.value = 0;

        if (addBtn) addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          addBtn.style.display = 'none';
          if (qtyBlock) qtyBlock.style.display = 'flex';
          if (input) input.value = 1;
          updateCTAForWrapper();
        });

        if (minusBtn) minusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var val = parseInt(input && input.value, 10) || 0;
          if (val > 1) {
            input.value = val - 1;
          } else {
            if (input) input.value = 0;
            if (qtyBlock) qtyBlock.style.display = 'none';
            if (addBtn) addBtn.style.display = 'inline-block';
          }
          updateCTAForWrapper();
        });

        if (plusBtn) plusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var val = parseInt(input && input.value, 10) || 0;
          input.value = val + 1;
          updateCTAForWrapper();
        });
      })(actions[a]);

      /* ----- Plan tabs ----- */
      var plans = wrapper.querySelectorAll('.bundle-plan');
      for (var p = 0; p < plans.length; p++) (function (plan) {
        plan.addEventListener('click', function () {
          for (var i2 = 0; i2 < plans.length; i2++) plans[i2].classList.remove('bundle-plan-active');
          plan.classList.add('bundle-plan-active');
          //syncSubscriptionSelectVisibility();
          updateCTAForWrapper();
        });
      })(plans[p]);

      var subSelect = wrapper.querySelector('.choose-bundle-subscription');
      if (subSelect) subSelect.addEventListener('change', function () { updateCTAForWrapper(); });

      /* ----- ATC (scoped & safe) ----- */
      if (atc && !atc.dataset.bound) {
        atc.dataset.bound = 'true';
        atc.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Require active state before building items
          if (!atc.classList.contains('is-active')) {
            // mode-specific message
            alert(cfg.emptyAlert);
            return;
          }

          var isSubscribe = wrapper.querySelector('.bundle-plan.bundle-plan-active') &&
                            wrapper.querySelector('.bundle-plan.bundle-plan-active').getAttribute('data-plan') === 'subscribe';
          var sellingPlanId = null;
          if (isSubscribe) {
            var activePlan = wrapper.querySelector('.bundle-plan.bundle-plan-active');
            var selectEl = activePlan ? activePlan.querySelector('.choose-bundle-subscription') : null;
            if (selectEl) {
              var sid = parseInt(selectEl.value, 10);
              if (!isNaN(sid)) sellingPlanId = sid;
            }
          }

          var items = [];
          var cards = wrapper.querySelectorAll(cfg.cardSelector);
          for (var c = 0; c < cards.length; c++) {
            var card  = cards[c];
            var qtyEl = card.querySelector('.bundle-qty-number');
            var idEl  = card.querySelector('.var-id');
            var qty   = parseInt(qtyEl && qtyEl.value, 10) || 0;
            var vid   = parseInt(idEl && idEl.value, 10) || 0;
            if (qty > 0 && vid) {
              var line = { id: vid, quantity: qty };
              if (sellingPlanId) line.selling_plan = sellingPlanId;
              items.push(line);
            }
          }

          if (!items.length) {
            alert(cfg.emptyAlert);
            return;
          }

          // Add shaker if subscription is active AND ATC has class atc-shaker-with-sub
          if (atc.classList.contains('atc-shaker-with-sub') && sellingPlanId) {
            items.push({
              id: 49560282005834,
              quantity: 1,
            });
          }


          // Loading state
          atc.classList.add("instant-loading");
          atc.style.cursor = "wait";
          atc.setAttribute("disabled", "disabled");

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (res) {
            if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
            return res.json();
          })
          .then(function () {
            var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            return fetch(cartUrl + '?section_id=cart-drawer')
              .then(function (res) { return res.text(); })
              .then(function (htmlText) {
                var html = new DOMParser().parseFromString(htmlText, 'text/html');
                var newDrawer = html.querySelector('.cart-drawer');
                var oldDrawer = document.querySelector('.cart-drawer');
                if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);

                var drawerEl = document.querySelector('cart-drawer');
                if (drawerEl) {
                  if (drawerEl.classList.contains('is-empty')) {
                    drawerEl.classList.remove('is-empty');
                  }
                  setTimeout(function () {
                    drawerEl.classList.add('active');
                    document.body.classList.add('overflow-hidden');
                  }, 300);
                }
              });
          })
          .catch(function (err) {
            console.error('Bundle add error:', err);
            alert('Could not add bundle to cart. Please try again.');
          })
          .finally(function () {
            atc.classList.remove("instant-loading");
            atc.style.cursor = "";
            atc.removeAttribute("disabled");
          });
        });
      }

      // Initial paint
      //syncSubscriptionSelectVisibility();
      updateCTAForWrapper();
    })(wrappers[w]);
  });
})();

(function() {
  function equalizeBundleVariantHeights() {
    var cards = document.querySelectorAll('.bundle-variant');
    if (!cards.length) return;

    // Reset heights
    cards.forEach(function(card) { card.style.height = ''; });

    // Only run on mobile
    if (window.innerWidth > 768) return;

    // Find max height
    var maxH = 0;
    cards.forEach(function(card) {
      var h = card.getBoundingClientRect().height;
      if (h > maxH) maxH = h;
    });

    // Apply max height
    cards.forEach(function(card) {
      card.style.height = maxH + 'px';
    });
  }

  window.addEventListener('load', equalizeBundleVariantHeights);
  window.addEventListener('resize', equalizeBundleVariantHeights);
})();

(() => {
  const OFFSET = 30; // e.g., 72 for a fixed header

  function scrollToTarget(el) {
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
    if (history.replaceState) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function findTarget(hash) {
  // only run on product pages
  if (!document.body.classList.contains('product')) {
    return null; // don’t mess with hashes outside product pages
  }

  if (!hash || hash === '#' || hash === '#!') return null;
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  return document.querySelector('#' + CSS.escape(raw)) || document.getElementById(raw);
}


  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;

    const url = new URL(a.getAttribute('href'), window.location.href);

    // Only handle same-page fragment links
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;

    const target = findTarget(url.hash);
    if (!target) return; // let default behavior if no target exists

    e.preventDefault();
    scrollToTarget(target);
  }, { passive: false });

  // If page loads with a hash, smooth scroll to it and then clean the URL
  window.addEventListener('load', () => {
    const target = findTarget(location.hash);
    if (target) scrollToTarget(target);
  });
})();

/* Bundles JS End */

// === MAGDEAL — config ===
const MAGDEAL = {
  variantId: 49549270384970,
  discountCode: "MAGDEAL",
  cartSections: ["cart-drawer", "cart-icon-bubble"],
  sessionFlag: "MAGDEAL_applied"
};

// === Helpers ===
function setLoading(atc, on) {
  if (!atc) return;
  if (on) {
    atc.classList.add("instant-loading");
    atc.style.cursor = "wait";
    atc.setAttribute("disabled", "disabled");
  } else {
    atc.classList.remove("instant-loading");
    atc.style.cursor = "";
    atc.removeAttribute("disabled");
  }
}

function findNearestQtySelector(fromEl) {
  let node = fromEl;
  while (node && node !== document.documentElement) {
    if (node.classList?.contains("MAGQtySelector")) return node;
    const found = node.querySelector?.(".MAGQtySelector");
    if (found) return found;
    node = node.parentElement;
  }
  return document.querySelector(".MAGQtySelector");
}

function getSelectedQty(selectorEl) {
  if (!selectorEl) return 3;
  const kids = Array.from(selectorEl.children).filter(Boolean);
  if (kids.length < 2) return 3;
  return kids[1].classList.contains("ActiveSelector") ? 3 : 1;
}

function initQtySelector(selectorEl) {
  if (!selectorEl) return;
  const kids = Array.from(selectorEl.children).filter(Boolean);
  if (kids.length < 2) return;

  kids.forEach(k => k.classList.remove("ActiveSelector"));
  kids[1].classList.add("ActiveSelector");

  kids.forEach((kid, idx) => {
    kid.addEventListener("click", (e) => {
      e.preventDefault();
      kids.forEach(k => k.classList.remove("ActiveSelector"));
      kid.classList.add("ActiveSelector");
      selectorEl.dataset.qty = (idx === 0) ? "1" : "3";
    });
  });
}

async function addToCart(variantId, quantity) {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ id: variantId, quantity })
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Add to cart failed (${res.status}). ${txt}`);
  }
  return res.json();
}

async function applyDiscountSilently(code) {
  if (sessionStorage.getItem(MAGDEAL.sessionFlag) === "1") return;
  try {
    await fetch(`/discount/${encodeURIComponent(code)}`, {
      method: "GET",
      credentials: "same-origin"
    });
    sessionStorage.setItem(MAGDEAL.sessionFlag, "1");
  } catch (err) {
    console.warn("Silent discount apply failed:", err);
  }
}

async function refreshCartSections() {
  const res = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ updates: {}, sections: MAGDEAL.cartSections })
  });
  if (!res.ok) return;
  const cart = await res.json().catch(() => null);
  try {
    document.querySelector("cart-drawer")?.renderContents(cart);
    document.querySelector("cart-drawer.drawer")?.classList.remove("is-empty");
  } catch {}
}

// === Boot ===
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".MAGQtySelector").forEach(initQtySelector);

  document.addEventListener("click", async (evt) => {
    const atc = evt.target.closest("a.magdeal-atc");
    if (!atc) return;

    evt.preventDefault();
    if (atc.hasAttribute("disabled")) return;

    setLoading(atc, true);

    try {
      const selectorEl = findNearestQtySelector(atc);
      const qty = selectorEl?.dataset?.qty ? parseInt(selectorEl.dataset.qty, 10) : getSelectedQty(selectorEl);

      await addToCart(MAGDEAL.variantId, Number.isFinite(qty) ? qty : 3);
      await applyDiscountSilently(MAGDEAL.discountCode);
      await refreshCartSections();

    } catch (err) {
      console.warn(err);
    } finally {
      setLoading(atc, false);
    }
  });
});
/*MAG DEAL END*/